module.exports = __webpack_public_path__ + "img/login_form.cd12bbda.png";